import constants from '../constants';
import { FormJson } from 'edocatbase/Form';
import axios from 'axios';

export const initForm = (formJson: FormJson, formInstanceId: string, innerFormInstanceId?: string) => ({
	type: constants.INIT_FORM,
	payload: formJson,
	formInstanceId,
	innerFormInstanceId,
});

export const destroyForm = (formInstanceId: string, innerFormInstanceId?: string) => ({
	type: constants.DESTROY_FORM,
	formInstanceId,
	innerFormInstanceId,
});

export const onFormChange = (
	formInstanceId: string,
	path: (string | number)[],
	value: any,
	innerFormInstanceId?: string
) => ({
	type: constants.ON_FORM_CHANGE,
	payload: { path, value },
	formInstanceId,
	innerFormInstanceId,
});

export const addNewContact = (
	formInstanceId: string,
	index: number,
	value: string,
	name: string,
	innerFormInstanceId?: string
) => ({
	type: constants.ADD_NEW_CONTACT,
	payload: { index, value, name },
	formInstanceId,
	innerFormInstanceId,
});

export const addAresField = (formInstanceId: string, name: string) => ({
	type: constants.ADD_ARES_FIELD,
	payload: name,
	formInstanceId,
});

export const removeAresField = (formInstanceId: string, name: string, index: number) => ({
	type: constants.REMOVE_ARES_FIELD,
	payload: { name, index },
	formInstanceId,
});

export const getSelectValue = (formInstanceId: string, name: string, multi: boolean, innerFormInstanceId?: string) => ({
	type: constants.GET_SELECT_VALUE,
	payload: { name, multi },
	formInstanceId,
	innerFormInstanceId,
});

export const makeFieldDirty = (formInstanceId: string, name: string, innerFormInstanceId?: string) => ({
	type: constants.MAKE_FIELD_DIRTY,
	payload: name,
	formInstanceId,
	innerFormInstanceId,
});

export const cleanFieldDirty = (formInstanceId: string, name: string, innerFormInstanceId?: string) => ({
	type: constants.CLEAN_FIELD_DIRTY,
	payload: name,
	formInstanceId,
	innerFormInstanceId,
});

export const makeAllFieldsDirty = (formInstanceId: string, innerFormInstanceId?: string) => ({
	type: constants.MAKE_ALL_FIELDS_DIRTY,
	formInstanceId,
	innerFormInstanceId,
});

export const highlightCurrentField = (
	formInstanceId: string,
	name: string,
	errorType: string | boolean = false,
	innerFormInstanceId?: string
) => ({
	type: constants.HIGHLIGHT_CURRENT_FIELD,
	payload: { name, errorType },
	formInstanceId,
	innerFormInstanceId,
});

export const highlightErrors = (
	formInstanceId: string,
	fields: { [key: string]: string | boolean },
	innerFormInstanceId?: string
) => ({
	type: constants.HIGHLIGHT_ERRORS,
	payload: fields,
	formInstanceId,
	innerFormInstanceId,
});

export const removeAssocItem = (formInstanceId: string, name: string, item: any, innerFormInstanceId?: string) => ({
	type: constants.REMOVE_ASSOC_ITEM,
	payload: { name, item },
	formInstanceId,
	innerFormInstanceId,
});

export const reArrangeAssocItems = (
	formInstanceId: string,
	name: string,
	item: any,
	index: number,
	direction: string,
	innerFormInstanceId?: string
) => ({
	type: constants.REARRANGE_ASSOC_ITEMS,
	payload: { name, item, index, direction },
	formInstanceId,
	innerFormInstanceId,
});

export const addConstraint = (formInstanceId: string, constraint: any, innerFormInstanceId?: string) => ({
	type: constants.ADD_CONSTRAINT,
	payload: constraint,
	formInstanceId,
	innerFormInstanceId,
});

export const removeConstraint = (formInstanceId: string, constraint: any, innerFormInstanceId?: string) => ({
	type: constants.REMOVE_CONSTRAINT,
	payload: constraint,
	formInstanceId,
	innerFormInstanceId,
});

export const dropValidation = (formInstanceId: string, innerFormInstanceId?: string) => ({
	type: constants.DROP_VALIDATION,
	formInstanceId,
	innerFormInstanceId,
});

export const clearFormValues = (formInstanceId: string) => ({
	type: constants.CLEAR_FORM_VALUES,
	formInstanceId,
});

export const getAresValues = (formInstanceId: string, name: string, index: number, ico: number | string) => ({
	type: constants.FETCH_ARES_VALUES,
	meta: { formInstanceId },
	payload: fetch(`${window.appContext}/proxy/alfresco/emvc/ares/${ico}`, {
		credentials: 'same-origin',
	})
		.then(response => {
			if (response.status !== 200) {
				throw { response, index, name };
			}
			return response.json();
		})
		.then(response => ({
			index,
			name,
			response,
		}))
		.catch(reason => {
			throw reason;
		}),
});

export const onFormSubmit = (
	formInstanceId: string,
	form: FormJson,
	url: string,
	method = 'POST',
	innerFormInstanceId?: string
) => ({
	type: constants.ON_FORM_SUBMIT_PROMISE,
	meta: { formInstanceId, innerFormInstanceId },
	payload: fetch(url, {
		credentials: 'same-origin',
		body: JSON.stringify(form),
		method,
		headers: {
			[window.Alfresco.util.CSRFPolicy.getHeader()]: window.Alfresco.util.CSRFPolicy.getToken(),
			'Content-Type': 'application/json',
		},
	})
		.then(async response => {
			const contentType = response.headers.get('content-type');
			const isJson = contentType && contentType.includes('application/json');

			if (response.status !== 200) {
				if (isJson) {
					return response.json().then(reason => {
						throw reason;
					});
				}

				throw response;
			}

			return {
				response: isJson ? await response.json() : '',
				result: 'OK',
				wfInfo: form,
			};
		})
		.catch(reason => {
			throw reason.message ? reason.message : reason;
		}),
});

export const fetchFieldOptions = (
	formInstanceId: string,
	param: string,
	name: string,
	innerFormInstanceId?: string,
	newValue: string = ''
) => ({
	type: constants.FETCH_FIELD_OPTIONS,
	meta: { formInstanceId, innerFormInstanceId },
	payload: fetch(`${window.appContext}/proxy/alfresco-api/-default-/public/alfresco/versions/1/tags?maxItems=500`, {
		credentials: 'same-origin',
	})
		.then(response => {
			if (response.status !== 200) {
				throw response.json();
			}

			return response.json();
		})
		.then(response => ({
			name,
			response,
			newValue,
		}))
		.catch(reason => {
			throw reason;
		}),
});

export const postTag = (name: string, data: string, formInstanceId: string, innerFormInstanceId: string) => ({
	type: constants.PROMISE_POST_TAG,
	meta: { formInstanceId, innerFormInstanceId },
	payload: fetch(
		`${
			window.appContext
		}/proxy/alfresco/api/tag/workspace/SpacesStore?${window.Alfresco.util.CSRFPolicy.getParameter()}=${window.Alfresco.util.CSRFPolicy.getToken()}`,
		{
			credentials: 'same-origin',
			method: 'POST',
			body: JSON.stringify(data),
			headers: {
				[window.Alfresco.util.CSRFPolicy.getHeader()]: window.Alfresco.util.CSRFPolicy.getToken(),
				'Content-Type': 'application/json',
			},
		}
	)
		.then(response => {
			if (response.status !== 200) {
				throw response.json();
			}

			return response.json();
		})
		.then(response => {
			if (response.itemExists) {
				throw new Error('Item exists');
			}
			return {
				name,
				response,
			};
		})
		.catch(reason => {
			throw reason;
		}),
});

export const fetchPackageItems = (
	formInstanceId: string,
	name: string,
	nodeRef = 'alfresco/sites/home',
	innerFormInstanceId?: string
) => ({
	type: constants.FETCH_ASSOC_ITEMS,
	meta: { formInstanceId, innerFormInstanceId },
	payload: fetch(
		`${window.appContext}/proxy/alfresco/api/forms/picker/node/${nodeRef}/children?selectableType=${encodeURIComponent(
			'cm:content'
		)}&size=1000`,
		{
			credentials: 'same-origin',
		}
	)
		.then(response => {
			if (response.status !== 200) {
				throw response.json();
			}

			return response.json();
		})
		.then(response => ({
			name,
			response,
		}))
		.catch(reason => {
			throw reason;
		}),
});

export const uploadPackageItems = (
	formInstanceId: string,
	formData: FormData,
	name: string,
	innerFormInstanceId: string,
	onProgress: Function
) => {
	const token = encodeURIComponent(window.Alfresco.util.CSRFPolicy.getToken());
	return {
		type: constants.PROMISE_UPLOAD_PACKAGE_ITEMS,
		meta: { formInstanceId, innerFormInstanceId },
		payload: axios({
			method: 'post',
			url: `${
				window.appContext
			}/proxy/alfresco/edocat/task/PackageItemsUploadPost?${window.Alfresco.util.CSRFPolicy.getParameter()}=${token}`,
			data: formData,
			headers: {
				[window.Alfresco.util.CSRFPolicy.getHeader()]: window.Alfresco.util.CSRFPolicy.getToken(),
			},
			onUploadProgress: event => onProgress(event),
		})
			.then(response => {
				if (response.status !== 200) {
					throw response.data;
				}

				return {
					...response.data,
					name,
				};
			})
			.catch(reason => {
				throw reason?.response?.data?.message || 'Error';
			}),
	};
};

export const uploadAttachment = (
	formInstanceId: string,
	formData: FormData,
	name: string,
	innerFormInstanceId: string,
	fileName: string,
	onProgress: Function
) => {
	const token = encodeURIComponent(window.Alfresco.util.CSRFPolicy.getToken());
	return {
		type: constants.PROMISE_UPLOAD_ATTACHMENT,
		meta: { formInstanceId, innerFormInstanceId },
		payload: axios({
			method: 'post',
			url: `${
				window.appContext
			}/proxy/alfresco/edocat/form/CreatePost?${window.Alfresco.util.CSRFPolicy.getParameter()}=${token}`,
			data: formData,
			headers: {
				[window.Alfresco.util.CSRFPolicy.getHeader()]: window.Alfresco.util.CSRFPolicy.getToken(),
			},
			onUploadProgress: event => onProgress(event),
		})
			.then(response => {
				if (response.status !== 200) {
					throw response.data;
				}

				return {
					nodeRef: response.data,
					name,
					fileName,
				};
			})
			.catch(reason => {
				throw reason?.response?.data?.message || 'Error';
			}),
	};
};

export const getNamesByNodesForTableProps = (
	formInstanceId: string,
	name: string,
	value: any,
	key: string,
	index: number
) => ({
	type: constants.FETCH_ITEMS_BY_NODES_FOR_TABLE,
	meta: { formInstanceId },
	payload: fetch(`${window.appContext}/proxy/alfresco/api/forms/picker/items`, {
		credentials: 'same-origin',
		method: 'POST',
		body: JSON.stringify({
			itemValueType: 'nodeRef',
			items: value,
		}),
		headers: {
			[window.Alfresco.util.CSRFPolicy.getHeader()]: window.Alfresco.util.CSRFPolicy.getToken(),
			'Content-Type': 'application/json',
		},
	})
		.then(response => {
			if (response.status !== 200) {
				throw response.json();
			}

			return response.json();
		})
		.then(response => ({
			response,
			name,
			key,
			index,
		}))
		.catch(reason => {
			throw reason;
		}),
});

export const getNamesByNodes = (
	formInstanceId: string,
	name: string,
	value: any,
	innerFormInstanceId?: string,
	isTable?: boolean
) => ({
	type: constants.FETCH_ITEMS_BY_NODES,
	meta: { formInstanceId, innerFormInstanceId },
	payload: fetch(`${window.appContext}/proxy/alfresco/api/forms/picker/items`, {
		credentials: 'same-origin',
		method: 'POST',
		body: JSON.stringify({
			itemValueType: 'nodeRef',
			items: value,
		}),
		headers: {
			[window.Alfresco.util.CSRFPolicy.getHeader()]: window.Alfresco.util.CSRFPolicy.getToken(),
			'Content-Type': 'application/json',
		},
	})
		.then(response => {
			if (response.status !== 200) {
				throw response.json();
			}

			return response.json();
		})
		.then(response => ({
			response,
			name,
			isTable,
		}))
		.catch(reason => {
			throw reason;
		}),
});

export const getValueByNodes = (formInstanceId: string, name: string, value: any, innerFormInstanceId?: string) => ({
	type: constants.FETCH_VALUE_BY_NODES,
	meta: { formInstanceId, innerFormInstanceId },
	payload: fetch(`${window.appContext}/proxy/alfresco/api/forms/picker/items`, {
		credentials: 'same-origin',
		method: 'POST',
		body: JSON.stringify({
			itemValueType: 'nodeRef',
			items: value,
		}),
		headers: {
			[window.Alfresco.util.CSRFPolicy.getHeader()]: window.Alfresco.util.CSRFPolicy.getToken(),
			'Content-Type': 'application/json',
		},
	})
		.then(response => {
			if (response.status !== 200) {
				throw response.json();
			}

			return response.json();
		})
		.then(response => ({
			response,
			name,
		}))
		.catch(reason => {
			throw reason;
		}),
});

export const fetchOptions = (formInstanceId: string, params: any, name: string, innerFormInstanceId?: string) => ({
	type: constants.FETCH_OPTIONS,
	meta: { formInstanceId, innerFormInstanceId },
	payload: {
		promise: fetch(`${window.appContext}/proxy/alfresco/emvc/codebook/byName?name=${params.qName}`, {
			credentials: 'same-origin',
		})
			.then(response => {
				if (response.status !== 200) {
					throw response.json();
				}

				return response.json();
			})
			.then(response => ({
				params,
				name,
				response,
			}))
			.catch(reason => {
				throw reason;
			}),
	},
});

export const fetchDataBox = (
	formInstanceId: string,
	params: any,
	dbid: string,
	name: string,
	value: any,
	init = false,
	innerFormInstanceId?: string
) => ({
	type: init ? constants.FETCH_INIT_DATA_BOX : constants.FETCH_DATA_BOX,
	meta: { formInstanceId, innerFormInstanceId },
	payload: fetch(`${params.fetchUrl}/${dbid}?${params.queryParamName}=${value}`, {
		credentials: 'same-origin',
	})
		.then(response => {
			if (response.status !== 200) {
				throw response.json();
			}

			return response.json();
		})
		.then(response => ({ params, name, response }))
		.catch(reason => {
			throw reason;
		}),
});

export const transitionSubmit = (formInstanceId: string, ready = false, innerFormInstanceId?: string) => ({
	type: constants.TRANSITION_SUBMIT,
	payload: ready,
	formInstanceId,
	innerFormInstanceId,
});
